import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChildsComponent } from './childs.component';



const childs: Routes = [
  {
    path: 'childs',
    component: ChildsComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(childs)
  ],
  exports: [
    RouterModule 
  ]
})
export class childsroutingmodule { }



// WEBPACK FOOTER //
// ./src/app/shell/Parent-Portal/childs/childs-routing.module.ts